import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Reveal from './Reveal';
import { PlusIcon } from './icons';
import './styles.scss';

const faqs = [
  {
    q: 'Is the 90-day trial really free?',
    a: 'Yes. No credit card, no commitment, no demo required. Run a real project with your real crews; if we don’t pay for ourselves before day 90, walk away. Already a SafetyLoop customer? Try it free for 6 months.',
  },
  {
    q: 'Who counts as a user?',
    a: 'Anyone added to a project — on your company or a sub’s. On the By Project plan, 50 active users are included and subcontractor accounts are free and unlimited to add. On the By User plan, every active user is $39/mo.',
  },
  {
    q: 'How does $599/project work on big jobs?',
    a: 'CA$599/mo flat fee per project. A $5M renovation or a $200M tower, same monthly fee. No annual contracts. 50 active users included. It typically beats By User once you cross roughly 16 users.',
  },
  {
    q: 'How do you actually compare to Procore on price?',
    a: 'Procore doesn’t publish list pricing; industry-cited figures run ~$105/user/mo or 1–3% of annual construction volume on a 12-month commitment. ProjectLoop’s pricing is public, flat, in CAD, and month-to-month. Your quote will vary — that’s rather the point.',
  },
  {
    q: 'How does ProjectLoop compare to Autodesk Forma Build and Fieldwire?',
    a: 'Both charge per seat. Fieldwire reserves RFIs and submittals for its top Business Plus tier, and Forma Build’s lowest rates require annual billing. ProjectLoop includes every tool on every plan, prices in CAD, runs month-to-month, and is fully integrated with SafetyLoop, TrafficLoop and ComplyLoop.',
  },
  {
    q: 'Does it work offline?',
    a: 'Yes. Drawings, forms, and daily logs are cached on device for poor-connectivity sites and sync automatically when you’re back in coverage.',
  },
  {
    q: 'Where does our data live?',
    a: 'In Canada — Canadian-owned infrastructure, CAD pricing, and support in your time zone.',
  },
  {
    q: 'What happens after the 90 days?',
    a: 'You pick a plan — or you don’t. Month-to-month after, cancel anytime. We earn your business by being better, not by locking you in.',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="plh-faq">
      <div className="plh-faq__inner">
        <Reveal className="plh-faq__lead">
          <p className="plh-eyebrow">Before you switch</p>
          <h2>
            Questions worth asking <span className="plh-accent">before the trial.</span>
          </h2>
          <p className="plh-faq__contact">
            Prefer a human? Talk to a builder — not a salesperson.{' '}
            <Link to="/contact_us">
              Contact us <span aria-hidden="true">→</span>
            </Link>
          </p>
        </Reveal>
        <Reveal className="plh-faq__list" delay={100}>
          {faqs.map((faq, idx) => {
            const isOpen = idx === openIndex;
            return (
              <div className={`plh-faq__item${isOpen ? ' is-open' : ''}`} key={faq.q}>
                <button
                  type="button"
                  aria-expanded={isOpen}
                  onClick={() => setOpenIndex(isOpen ? -1 : idx)}
                >
                  <span>{faq.q}</span>
                  <span className="plh-faq__toggle" aria-hidden="true">
                    <PlusIcon />
                  </span>
                </button>
                <div className="plh-faq__answer">
                  <div>
                    <p>{faq.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </Reveal>
      </div>
    </section>
  );
}
